// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"d06fd74d","885":"aab5ddfb"}[chunkId] + ".chunk.js";
};